<div class="sp-dashboard-container">
  <sp-header></sp-header>

  <main class="sp-main">

    <!-- Page header -->
    <div class="sp-page-header">
      <div class="sp-greeting">
        <h1>{{ greeting }}!</h1>
        <p>Here's what's happening with your workspace today</p>
      </div>
      <div class="sp-header-actions">
        <button class="sp-refresh-btn" (click)="refreshDashboard()" [disabled]="isLoading">
          <span class="material-icons" [class.spinning]="isLoading">refresh</span>
        </button>
        <div class="sp-date-display">
          <span class="material-icons">calendar_today</span>
          {{ today | date:'EEEE, MMMM d, yyyy' }}
        </div>
      </div>
    </div>

    <!-- Stat cards -->
    <section class="sp-stats-section">
      <div class="sp-stat-card" (click)="openMyWork('me')" style="cursor:pointer;" title="Open my unified task inbox">
        <div class="sp-stat-icon tasks"><span class="material-icons">pending_actions</span></div>
        <div class="sp-stat-content">
          <div class="sp-stat-value">{{ stats.pendingTasks | number }}</div>
          <div class="sp-stat-label">My pending tasks</div>
        </div>
      </div>
      <div class="sp-stat-card" (click)="openMyWork('group')" style="cursor:pointer;" title="Open tasks claimable by my groups">
        <div class="sp-stat-icon folders"><span class="material-icons">groups</span></div>
        <div class="sp-stat-content">
          <div class="sp-stat-value">{{ stats.myClaimable | number }}</div>
          <div class="sp-stat-label">Claimable by my groups</div>
        </div>
      </div>
      <div class="sp-stat-card" (click)="openMyCompleted()" style="cursor:pointer;" title="View tasks I have completed">
        <div class="sp-stat-icon completed"><span class="material-icons">task_alt</span></div>
        <div class="sp-stat-content">
          <div class="sp-stat-value">{{ stats.completed | number }}</div>
          <div class="sp-stat-label">Completed</div>
        </div>
      </div>
      <div class="sp-stat-card">
        <div class="sp-stat-icon uploads"><span class="material-icons">cloud_upload</span></div>
        <div class="sp-stat-content">
          <div class="sp-stat-value">{{ stats.recentUploads | number }}</div>
          <div class="sp-stat-label">My uploads — last 30 days</div>
        </div>
      </div>
    </section>


    <!-- Row 2.5: Workflow analytics (native — GET /api/wf/analytics/summary) -->
    <div class="sp-row-analytics">
      <section class="sp-card sp-an-card">

        <div class="sp-an-head">
          <div class="sp-card-header">
            <span class="material-icons">insights</span>
            <h2>Workflow analytics</h2>
          </div>
          <div class="sp-an-range">
            <label for="anDays">Trend window</label>
            <select id="anDays" (change)="onAnalyticsDaysChange(+$any($event.target).value)">
              <option [value]="7"  [selected]="analyticsDays === 7">Last 7 days</option>
              <option [value]="14" [selected]="analyticsDays === 14">Last 14 days</option>
              <option [value]="30" [selected]="analyticsDays === 30">Last 30 days</option>
            </select>
          </div>
        </div>

        <div class="sp-an-grid">

          <!-- Active tasks by workflow + mini-stats -->
          <div>
            <p class="sp-an-sub">Active tasks by workflow</p>

            <div class="sp-an-bars" *ngIf="analytics?.tasksByWorkflow?.length">
              <div class="sp-an-bar-row" *ngFor="let w of analytics.tasksByWorkflow">
                <span class="sp-an-bar-name" [title]="w.label">{{ w.label }}</span>
                <span class="sp-an-bar-track">
                  <span class="sp-an-bar-fill" [style.width]="barWidth(w.value)"></span>
                </span>
                <span class="sp-an-bar-val">{{ w.value }}</span>
              </div>
            </div>
            <p class="sp-an-empty" *ngIf="analytics && !analytics.tasksByWorkflow?.length">No active tasks</p>

            <div class="sp-an-mini" *ngIf="analytics">
              <div class="sp-an-mini-card">
                <div class="sp-an-mini-label">Overdue (SLA)</div>
                <div class="sp-an-mini-val danger">{{ analytics.overdueCount }}</div>
              </div>
              <div class="sp-an-mini-card">
                <div class="sp-an-mini-label">Avg cycle</div>
                <div class="sp-an-mini-val">{{ analytics.avgCycleDays }}d</div>
              </div>
            </div>
          </div>

          <!-- Completion trend -->
          <div class="sp-an-trend">
            <p class="sp-an-sub">Completed · last {{ analyticsDays }} days</p>
            <svg viewBox="0 0 260 110" *ngIf="analytics" preserveAspectRatio="none">
              <line x1="0" y1="100" x2="260" y2="100" stroke="#eef1f4" stroke-width="1"></line>
              <polyline fill="none" stroke="#1D9E75" stroke-width="2" [attr.points]="analyticsTrendPoints"></polyline>
              <circle [attr.cx]="analyticsTrendLastX" [attr.cy]="analyticsTrendLastY" r="3" fill="#1D9E75"></circle>
            </svg>
            <p class="sp-an-sub" *ngIf="analytics" style="margin-top:6px;">{{ analytics.totalCompleted }} completed this period</p>
          </div>

        </div>

        <div class="sp-an-foot" *ngIf="!analyticsLoading">All figures from one tenant-scoped query — no repository scan</div>
        <div class="sp-an-foot" *ngIf="analyticsLoading">Loading analytics…</div>

      </section>
    </div>

    <!-- Row 3: Quick actions -->
    <div class="sp-row-3">

      <!-- Quick actions -->
      <section class="sp-card sp-quick-actions">
        <div class="sp-card-header">
          <span class="material-icons">flash_on</span>
          <h2>Quick actions</h2>
        </div>
        <div class="sp-actions-grid">
          <button *ngFor="let action of quickActions" class="sp-action-btn" (click)="navigateTo(action.route)">
            <div class="sp-action-icon" [style.background-color]="action.color">
              <span class="material-icons">{{ action.icon }}</span>
            </div>
            <span class="sp-action-label">{{ action.label }}</span>
          </button>
        </div>
      </section>

    </div>

  </main>
</div>